/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import {
    View,
    Pressable,
    FlatList,
    Text,
    Share,
    Platform, SafeAreaView
} from 'react-native';
import { Loader,
CatalogCard,
Locked,
FullScreenImageLoader,
} from '../../components';
import styles from './styles';
import { Icon, Divider } from 'react-native-elements';
import { Firestore, Crashlytics, Analytics } from '../../firebase/config';
import { DeepLink } from '../../utilities';
import { WebView } from 'react-native-webview';

export default function SingleCatalog(props) {
const [payload2, setPayload2] = useState(false);
const [catalog, setCatalog] = useState([]);
const [catalogs, setCatalogs] = useState([]);
const [loading, setLoading] = useState(true);
const [locked, setLocked] = useState(false);
const [splitScreen, setSplitScreen] = useState(false);
const [catalogBrowser, setCatalogBrowser] = useState(true);
const [sharePayload1, setSharePayload1] = useState(null);
const [sharePayload2, setSharePayload2] = useState(null);
const catalogID = props.route.params.catalogID;
const pg = props.route.params.pg;
//const productLines = props.extraData.productLines;
const productLines = props.extraData?.productLines? props.extraData.productLines : null;
const catalogsRef = Firestore.collection('Files').doc('Catalogs').collection('Empire Catalogs');
const { navigation } = props;
const canGoBack = navigation.canGoBack();

useEffect(() => {
catalogsRef.doc(catalogID)
.get()
.then((doc) => {
    let url;
if (pg) {
 url = doc.data().flipbook + pg;
}
else {
 url = doc.data().flipbook;
}
const catalogData = {
image: doc.data().image,
flipbook: url,
title: doc.data().title,
description: doc.data().description,
productLine: doc.data().productLine,
}
catalogData.id = doc.id;
setCatalog(catalogData);
setLoading(false);
}).catch((err) => {
console.error("Error loading source catalog: ", err);
Crashlytics.recordError(err);
if (err.code === "permission-denied") {
setLocked(true);
setLoading(false);


Analytics.logEvent('locked', {
    screen: 'ViewCatalog',
    type: 'Catalog',
    purpose: 'View Catalog',
    catalogID: catalogID
    });


}
});
},[]);

//Gets All Catalogs
const fetchCatalogs = () => {
    console.log(`Product Lines: ${productLines}`)
    let query;
    if (!productLines) {
        query = catalogsRef
            .where('visibility', '==', 'public')
            .orderBy('z-index', 'asc')
            .get()
    }
    else {
        query = catalogsRef
            .where('productLine', 'in', productLines)
            .orderBy('z-index', 'asc')
            .get()
    }

query.then((querySnapshot) => {
const allCatalogsData = [];
querySnapshot.forEach((doc) => {
const catalogData = {
image: doc.data().image,
flipbook: doc.data().flipbook,
title: doc.data().title,
description: doc.data().description,
productLine: doc.data().productLine
}
catalogData.id = doc.id;
allCatalogsData.push(catalogData);
});
setCatalogs(allCatalogsData);
}).catch((err) => {
console.error("Error loading all catalogs: ", err);
Crashlytics.recordError(err);
});
}


useEffect(() => {
if (catalog) {
if (!(canGoBack)){
navigation.setOptions({
title: catalog.title,
headerRight: () => (
<Pressable
style={{ position: 'absolute', right: 15 }}
onPress={() => {
toggleScreenSplit();
}}>
<Icon
name='vertical-split'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
headerLeft: () => (
<Pressable
style={{ position: 'absolute', left: 15 }}
onPress={() => {
navigation.navigate("Catalogs/AllCatalogs")}}>
<Icon
name='home'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
});
}
else {
navigation.setOptions({
title: catalog.title,
headerRight: () => (
<Pressable
style={{ position: 'absolute', right: 15 }}
onPress={() => {
toggleScreenSplit();
}}>
<Icon
name='vertical-split'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
});
}
}
else if (locked) {
navigation.setOptions({
title: "Locked",
headerLeft: () => (
<Pressable
style={{ position: 'absolute', left: 15 }}
onPress={() => {
navigation.navigate("Catalogs/AllCatalogs")}}>
<Icon
name='home'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
})
}
},[catalog, splitScreen, locked]);




const getCatalogs = () => {
fetchCatalogs()
setSplitScreen(true);
setLoading(false);
}



//Handles changes in WebView url
const navChange = (navState, payload) => {
    console.log(`Payload: ${JSON.stringify(payload)}`);
    console.log(`New URL: ${JSON.stringify(navState.url)}`);
    let navShareParams;
switch (payload) {
case "payload1":
 navShareParams = {
catalogID: catalog.id,
url: navState.url
}
setSharePayload1(navShareParams);
break;
case "payload2":
 navShareParams = {
catalogID: payload2.id,
url: navState.url
}
setSharePayload2(navShareParams);
break;
}
}


function startAnalytics(catalogID) {
 return Analytics.logEvent('share', {
 screen: 'CatalogView',
 type: 'Catalog',
 purpose: 'Share Catalog',
 catalogID: catalogID,
 });
 }


const getPageNumber = (url) => {
const split = url.split('#p=');
return split[1];
}


const generateShareLink = (payload) => {
    let sharePayload;
    let shareTitle;
    let shareParams;
switch (payload) {
case "payload1":
 sharePayload = sharePayload1;
break;
case "payload2":
 sharePayload = sharePayload2;
}
if (Platform.OS === 'web') {
 shareTitle = "Click the link to view the catalog: ";
}
else {
 shareTitle = "Click the link to view the " + sharePayload.catalogID + " Catalog!";
}
return onShare(shareTitle, DeepLink('Catalogs/ViewCatalog', {catalogID: sharePayload.catalogID, pg: getPageNumber(sharePayload.url)}), sharePayload.title);
};

 const onShare = async (message, url, catalogID) => {
 startAnalytics(catalogID);
          try {
              let result;
           if (Platform.OS === 'android') {
             result = await Share.share({
              message: url,
            });
           }
           else {
             result = await Share.share({
              message: message,
              url: url
            });
           }
            if (result.action === Share.sharedAction) {
              if (result.activityType) {
                // shared with activity type of result.activityType
              } else {
                // shared
              }
            } else if (result.action === Share.dismissedAction) {
              // dismissed
            }
          } catch (err) {
          console.error("Error sharing catalog: ", err);
          Crashlytics.recordError(err);
            alert(error.message);
          }
        };


const renderCatalog = ({item, index}) => {
return (
<CatalogCard
 title={item.title}
 onPress={() => {
 const data = {
 title: item.title,
 payload: item.flipbook,
 id: item.id
 }
 setPayload2(data);
 setCatalogBrowser(!catalogBrowser);
 }}
 image={item.image}
 description={item.description}
 splitScreen={true}
 />
)
}

const toggleScreenSplit = () => {
switch (splitScreen) {
case true:
setSplitScreen(false);
setCatalogBrowser(true);
break;
case false:
if (!catalogs.length) {
getCatalogs();
}
setSplitScreen(true);
break;
}
}

if (loading) {
   return (
 <FullScreenImageLoader/>
   )
 }

if (locked) {
   return (
   <Locked onPress={() => {navigation.navigate('Catalogs')}}/>
   )
 }

return (
<>
{catalog && (
<>
{splitScreen && catalogs ? (
<>
<SafeAreaView style={styles.catalogTitleContainer}>
{Platform.OS !== 'web' &&
<Pressable
onPress={() => {generateShareLink("payload1");}}
>
{Platform.OS === 'ios'? (
<Icon
 name="ios-share"
 color="white"
 style={{flexDirection: 'row', justifyContent: 'flex-end', right: 10}}
/>
) : (
<Icon
 name="share"
 color="white"
 style={{flexDirection: 'row', justifyContent: 'flex-end', right: 10}}
/>
)}
</Pressable>
}
</SafeAreaView>

{Platform.OS === 'web'?
<iframe src={catalog.flipbook} height={"100%"} width={"100%"} frameBorder={0}/>
:
<WebView
source={{uri : catalog.flipbook}}
onNavigationStateChange={(navState) => {navChange(navState, "payload1");}}
/>
}
<Divider
color={'darkgray'}
width={2}
/>
{catalogs &&
<>
{catalogBrowser ? (
<View style={styles.listContainer}>
<FlatList
data={catalogs}
renderItem={renderCatalog}
keyExtractor={(item) => item.id}
removeClippedSubviews={true}
ListEmptyComponent={<Loader />}
showsHorizontalScrollIndicator={false}
horizontal={true}
/>
</View>
):(
<>
<View style={styles.catalog2TitleContainer}>
<View style={{marginLeft: 10}}></View>
<Text style={styles.catalog2Title}>{payload2.title}</Text>
{Platform.OS !== 'web' &&
<Pressable
onPress={() => {generateShareLink("payload2");}}
>
{Platform.OS === 'ios'? (
<Icon
 name="ios-share"
 color="white"
 style={styles.catalog2ShareIcon}
/>
) : (
<Icon
 name="share"
 color="white"
 style={styles.catalog2ShareIcon}
/>
)}
</Pressable>
}
</View>
<Divider
color={'darkgray'}
width={1}
/>
{Platform.OS === 'web'?
<iframe src={payload2.payload} height={"100%"} width={"100%"} frameBorder={0}/>
:
<WebView
source={{uri: payload2.payload}}
onNavigationStateChange={(navState) => {navChange(navState, "payload2");}}
/>
}
</>
)}
</>
}
</>
):(
<>
<View style={styles.catalogTitleContainer}>
{Platform.OS !== 'web' &&
<Pressable
onPress={() => {generateShareLink("payload1");}}
>
{Platform.OS === 'ios'? (
<Icon
 name="ios-share"
 color="white"
 style={{flexDirection: 'row', justifyContent: 'flex-end', right: 10}}
/>
) : (
<Icon
 name="share"
 color="white"
 style={{flexDirection: 'row', justifyContent: 'flex-end', right: 10}}
/>
)}
</Pressable>
}
</View>
{Platform.OS === 'web'?
<iframe src={catalog.flipbook} height={"100%"} width={"100%"} frameBorder={0}/>
:
<WebView
source={{uri : catalog.flipbook}}
onNavigationStateChange={(navState) => {navChange(navState, "payload1");}}
/>
}
</>
)}
</>
)}
</>
)
}